// ----------------------------------------------------------------------------
// Component: Image & Product Grid
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_image-product-grid.scss';


// Selectors
const PRODUCTS_IMAGE_GRID_SELECTOR = '.image-product-grid__products-image';
const PRODUCT_CARD_IMAGE_WRAPPER_SELECTOR = '.card__image-wrapper';
const PRODUCT_IMAGE_GRID_IMG_SELECTOR = '.image-product-grid__image';

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    const productsImageGridSections = document.querySelectorAll(PRODUCTS_IMAGE_GRID_SELECTOR);
    const mobileMedia = window.matchMedia('(max-width: 679px)');

    productsImageGridSections.forEach((productsImageGrid) => {
        const productCardImageWrapper = productsImageGrid.querySelector(PRODUCT_CARD_IMAGE_WRAPPER_SELECTOR);
        const productImageGridImg = productsImageGrid.querySelector(PRODUCT_IMAGE_GRID_IMG_SELECTOR);

        if( productCardImageWrapper && productImageGridImg) {
            let productCardImageHeight = productCardImageWrapper.offsetHeight;

            if (!mobileMedia.matches) {
                productImageGridImg.style.height = productCardImageHeight + 'px';
            }

            window.addEventListener('resize', function() {
                productCardImageHeight = productCardImageWrapper.offsetHeight;

                if (!mobileMedia.matches) {
                    productImageGridImg.style.height = productCardImageHeight + 'px';
                }
            });
        }
    });
});
